import { styled } from 'linaria/react';
import { breakpoints } from 'common/styles/breakpoints';

export const StoreRoutesContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: 2 / 1 / 3 / 2;
  row-gap: 24px;
  ${breakpoints.only.tablet} {
    display: grid;
    grid-area: 3 / 1 / 3 / 2 !important;
    grid-gap: var(--space-300);
    grid-template-columns: 1fr 1fr;
  }
  ${breakpoints.to.desktop} {
    grid-area: 2 / 1 / 3 / 2;
  }
`;

export const GreyRoundedSquare = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-right: 24px;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
`;

export const RoutesTextRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
